import { Link } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import SetPassword from './SetPassword';

/** /account/password — landing page for password-reset emails. */
export default function AccountPassword() {
  return (
    <AuthLayout title="Set a new password">
      <SetPassword />
      <p className="text-center text-sm mt-6">
        <Link to="/" className="text-ink font-medium hover:underline">Back to my card</Link>
      </p>
    </AuthLayout>
  );
}
